import { SignalRMethods } from '@app/AppConstants/SignalR';

import DateTimeService from '@app/Services/DateTimeService';
import { signalRService } from '@app/Services/SignalRService';

class PersonActivityStore {
    private _isActive: boolean;
    private _lastActivityDate: Date;

    constructor() {
        this._setLastActivityDate();
    }

    public startChecking = () => {
        window.addEventListener('focus', this._onFocus);
        window.addEventListener('blur', this._onBlur);
        if (!document.hidden){
            this.updatePersonIsActive(true);
            this.updatePersonLastActivity();
        }
    };

    public stopChecking = () => {
        window.removeEventListener('focus', this._onFocus);
        window.removeEventListener('blur', this._onBlur);
    };

    public updatePersonIsActive = (isActive: boolean) => {
        if (this._isActive !== isActive) {
            this._isActive = isActive;

            this.sendPersonIsActive(isActive);
        }
    };

    public sendPersonIsActive = (isActive: boolean) => {
        signalRService.sendNotification(SignalRMethods.updatePersonIsActive, isActive);
    };

    public updatePersonLastActivity = () => {
        this._setLastActivityDate();
        this.sendPersonLastActivity();
    };

    public sendPersonLastActivity = () => {
        signalRService.sendNotification(SignalRMethods.updatePersonLastActivity, this._lastActivityDate);
    };

    private _onFocus = () => {
        this.updatePersonIsActive(true);
        this.updatePersonLastActivity();
    };

    private _onBlur = () => {
        this.updatePersonIsActive(false);
        this.updatePersonLastActivity();
    };

    private _setLastActivityDate = () => {
        this._lastActivityDate = DateTimeService.now();
    };
}

export const personActivityStore = new PersonActivityStore();
